<div class="ci-card mb-2" [class.ci-card-open]="isOpen">

  <div class="ci-header" (click)="toggleDropdown()">
    <div class="ci-chevron" *ngIf="culture.content">
      <i class="fa-solid" [class.fa-chevron-right]="!isOpen" [class.fa-chevron-down]="isOpen"></i>
    </div>
    <div class="ci-chevron ci-chevron-placeholder" *ngIf="!culture.content"></div>

    <div class="ci-info">
      <div class="ci-name">{{ culture.name }}</div>
    </div>

    <div class="ci-actions" *ngIf="culture.content" (click)="$event.stopPropagation()">
      <button type="button" class="ci-action-btn" (click)="toggleDropdown()" [title]="'Aperçu' | translate">
        <i class="fa-regular fa-eye"></i>
      </button>
    </div>
  </div>

  <div class="ci-content" [@DropdownAnimation]="isOpen ? 'open' : 'closed'">
    <div class="ci-content-inner" [innerHTML]="culture.content | safeHtml"></div>
  </div>

</div>
